import "./_tooltip-content.scss";

import classNames from "classnames";

import {TypographyProps} from "../../typography/Typography";

interface TooltipContentProps {
  children: React.ReactNode;
  typography?: TypographyProps<"div">["variant"];
  customClassName?: string;
}

function TooltipContent({
  children,
  typography = "caption",
  customClassName
}: TooltipContentProps) {
  return (
    <div
      className={classNames(
        "tooltip-content",
        "has-default-border-radius",
        `typography--${typography}`,
        customClassName
      )}>
      {children}
    </div>
  );
}

export default TooltipContent;
